let Vue = window.Vue;
new Vue({
    el: '#content',
    data () {
        return {
            pageData: window.pageData(),
            navContentHeight: 58,
            courseList: [],
            screenClass: [],
            screenLevel: [],
            classIndex: '',
            levelIndex: '',
            priceOrder: '',
            isNewest: 1,
            pageIndex: 0,
            inputVal: '',
            pageSize: null,
            totalCount:null,
            showPagination: 0,
            currentPage: 1,
            majorList: [],
            allMajorList: [],
            projectList: [],
            isShowPurchaseAll: false,
            addCartCount: false,
            count: 0,
            showPopper: false,
            popperType: '',
            showSearchBtn: true,
            addWidth: {
            width: 30
            }
        };
    },
    mixins: [window.globalMixin, window.utilsMixin],
    created () {
        this.courseList = this.pageData.courseList;
        this.totalCount = this.pageData.totalCount;
        this.pageSize = this.pageData.pageSize || 16;
        this.pageIndex = this.pageData.pageIndex || 0;
        this.showPagination = Math.ceil(this.totalCount / this.pageSize);
        this.projectList = this.pageData.projectList;
        if (this.pageData.active) {
            if (this.pageData.active.projectId !== undefined && this.pageData.active.projectIndex !== undefined) {
                this.classIndex = this.pageData.active.projectId;
                // 初始化专业数据
                let item = this.projectList[this.pageData.active.projectIndex];
                this.majorList = item.majorList;
                this.isShowPurchaseAll = item.isShowPurchaseAll;
            }
            if (this.pageData.active.majorId !== undefined) {
                this.levelIndex = this.pageData.active.majorId;
            }
        } else {
            this.projectList.forEach(item => {
                if (item.majorList && item.majorList.length) {
                    this.allMajorList = this.allMajorList.concat(item.majorList)
                }
            });
            this.majorList = this.allMajorList;
        }
    },
    methods: {
        // 鼠标进入课程赛选导航 默认展示一行，鼠标进入如果内容大于一行则悬浮展示全部内容 离开恢复
        handleMouseEnterNavContent (e) {
            if (e.target.scrollHeight > e.target.offsetHeight) {
                // 不止一行
                let marginBottom = 10;
                e.target.style.height = e.target.scrollHeight + marginBottom + 'px';
                e.target.style.boxShadow = '0px 3px 6px rgba(0, 0, 0, 0.16)';
                e.target.style.backgroundColor = '#fff';
            }
        },
        handleMouseLeaveNavContent (e) {
            e.target.style.height = this.navContentHeight + 'px';
            e.target.style.boxShadow = 'none';
            e.target.style.backgroundColor = 'transparent';
        },
        // 项目切换 全部 val''
        changeProject (val,arr,isShowPurchaseAll) {
            this.classIndex = val;
            this.levelIndex = '';
            this.resetPageIndex();
            this.isShowPurchaseAll = isShowPurchaseAll;
            this.majorList = arr || [];
            // this.loadData();
            if (val === '') {
                this.jumpCourseList();
            } else {
                this.jumpCourseList('1');
            }
        },
        // 专业切换 全部 id为''
        changeLevel (id) {
            if (this.classIndex === '' && id) {
                // 项目为全部，点击具体某一个专业，需将项目切换为专业对应的项目，并且专业列表变为对应项目的专业列表
                let currentProject = this.projectList.find(projectItem => projectItem.majorList && projectItem.majorList.length && projectItem.majorList.some(majorItem => majorItem.id === id));
                this.classIndex = currentProject.id;
                this.majorList = currentProject.majorList;
            }
            this.levelIndex = id;
            this.resetPageIndex();
            this.jumpCourseList('2');
        },
        jumpCourseList (val) {
            if (val === '1') {
                this.toUrl(`/learning/courseList?projectId=${this.classIndex}`);
            } else if (val === '2') {
                this.toUrl(`/learning/courseList?projectId=${this.classIndex}&majorId=${this.levelIndex}`);
            } else {
                this.toUrl(`/learning/courseList`);
            }
        },
        changeIcon () {
            this.resetPageIndex();
            this.isNewest = '';
            if (this.priceOrder === '' || this.priceOrder === '2') {
                this.priceOrder = '1';
            } else {
                this.priceOrder = '2';
            }
            this.loadData();
        },
        // 还原页码
        resetPageIndex () {
            this.pageIndex = 0;
            this.currentPage = 1;
        },
        // 切换排序 1 综合 2 最新
        changeNewest (val) {
          this.isNewest = val;
          this.priceOrder = '';
          this.resetPageIndex();
          this.isNewest = val;
          this.loadData();
        },
        //购买项目下的所有课程
        payAllCourse () {
            this.loginResolve().then(() => {
                let data = {
                    projectId: this.classIndex,
                    majorId: ''
                };
                window.axios({
                    url:'/user/courseBatchAddCard',
                    method: 'post',
                    data: window.Qs.stringify(data)
                }).then(res => {
                    console.log(res, '加入的课程数量');
                    if (res.data.success) {
                        this.count = res.data.record.count;
                        this.addCartCount = true;
                    } else {
                        this.$message.warning(res.data.message);
                    }
                });
            });

        },
        // 获取数据
        loadData () {
            let data = {
                searchOrder: this.isNewest,
                majorId: this.levelIndex || '',
                projectId:  this.classIndex || '',
                pageIndex: this.pageIndex,
                searchText: this.inputVal || '',
                priceOrder: this.priceOrder
            };
            window.axios({
                url:'/index/templatePage/courseSearch',
                method: 'post',
                data: window.Qs.stringify(data)
            }).then(res => {
                if (res.data.success) {
                    window.scrollTo(0,0);
                    let record = res.data.record;
                    this.courseList = record.courseList || [];
                    this.totalCount = record.totalCount;
                    this.pageSize = record.pageSize;
                    this.pageIndex = record.pageIndex ;
                    this.showPagination = Math.ceil(this.totalCount / this.pageSize);
                }
            });
        },
        goCart () {
            this.toUrl('/learning/cart');
        },
        continueBrow () {
            this.addCartCount = false;
        },
        // 右侧搜索
        searchVal () {
            this.resetPageIndex();
            this.loadData();
        },
        // 尾页
        /*lastPage () {
            this.pageIndex = this.showPagination-1;
            this.currentPage = this.showPagination;
            this.loadData();
        },*/
        // 切换页码
        handleCurrentChange(val) {
            this.newList = [];
            if (val) {
                this.pageIndex = val-1;
            }
            this.loadData();
        },
        goCourseDetail (id) {
          // this.toUrl( '/learning/courseDetail?courseId=' +id);
          this.openUrl('/learning/courseDetail?courseId=' +id);
        },
        onUserLogin () {
            this.popperType = 'login';
            this.$nextTick(() => {
                this.showPopper = true;
            });
        },
        getPopper () {
            switch (this.popperType) {
                case 'login':
                    return 'head-login';
                case 'register':
                    return 'head-register';
                case 'forgetPwd':
                    return 'head-forget-pwd';
            }
        },
        onUserRegister () {
            this.popperType = 'register';
            this.$nextTick(() => {
                this.showPopper = true;
            });
        },
        onForgetPwd () {
            this.popperType = 'forgetPwd';
            this.$nextTick(() => {
                this.showPopper = true;
            });
        },
        onUserLogout () {
            window.axios({
                url: '/index/account/logout',
                method: 'post'
            }).then(response => {
                let data = response.data;
                if (data.errorCode === 0) {
                    this.toUrl('/learning/home');
                }
            }, () => {
                this.$message.warning('注销退出失败');
            });
        },
        showSearch () {
            this.showSearchBtn = false;
        }
    }
});
